import React from "react";
import Table from "react-bootstrap/Table";
import { FaAppStore } from "react-icons/fa";
import styled from "styled-components";
import '../styles/table.scss'

function Tables() {
    

    const StoreVisitors = styled(FaAppStore)`
    background-color: #fbc01c;
    color: #f9ffff;
  `;
  return (

    <div style={{ overflow: 'auto' }}>
    <Table >
       
    white-space: nowrap;
      <thead style={{ background: "#242D34", color: '#A5A7B1' }}>
        <tr>
          <th>Product Name</th>
          <th>ID Order</th>
          <th>Customer</th>
          <th>Price</th>
          <th>Payment Method</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody className="bodys" style={{ whiteSpace: 'nowrap' }}>
        <tr>
          <td>
            <div className="contents d-flex ">
              <div className="icons ">
                <StoreVisitors  style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      
                      }}/>
              </div>
              <div className="iconscontent px-2">
                <div>The count of Monte Cristo</div>
                <div>ID: 43756</div>
              </div>
            </div>
          </td>
          <td>Mark</td>
          <td>Otto</td>
          <td>$3.50</td>
          <td>Otto</td>
          <td>
           
               <span  style={{
                      
                        paddingRight: "8px",
                        paddingLeft: "8px",
                        paddingTop : '3px',
                        paddingBottom : '3px',
                        borderRadius: "5px",
                         color : '#7060FF',
                         background : '#262B31',
                      }}>Delivery</span>
           
          </td>
        </tr>
        <tr>
        <td>
            <div className="contents d-flex ">
              <div className="icons ">
                <StoreVisitors  style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      
                      }}/>
              </div>
              <div className="iconscontent px-2">
                <div>The count of Monte Cristo</div>
                <div>ID: 43756</div>
              </div>
            </div>
          </td>
          <td>Mark</td>
          <td>Otto</td>
          <td>$3.50</td>
          <td>Otto</td>
          <td> <span  style={{
                      
                      paddingRight: "8px",
                      paddingLeft: "8px",
                      paddingTop : '3px',
                      paddingBottom : '3px',
                      borderRadius: "5px",
                       color : '#7060FF',
                       background : '#262B31',
                    }}>Delivery</span></td>
          
        </tr>
        <tr>
        <td>
            <div className="contents d-flex ">
              <div className="icons ">
                <StoreVisitors  style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      
                      }}/>
              </div>
              <div className="iconscontent px-2">
                <div>The count of Monte Cristo</div>
                <div>ID: 43756</div>
              </div>
            </div>
          </td>
          <td>Mark</td>
          <td>Otto</td>
          <td>$3.50</td>
          <td>Otto</td>
          <td> <span  style={{
                      
                      paddingRight: "8px",
                      paddingLeft: "8px",
                      paddingTop : '3px',
                      paddingBottom : '3px',
                      borderRadius: "5px",
                       color : '#1ECE4F',
                       background : '#262B31',
                    }}>Delivery</span></td>
          
        </tr>
        <tr>
        <td>
            <div className="contents d-flex ">
              <div className="icons ">
                <StoreVisitors  style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      
                      }}/>
              </div>
              <div className="iconscontent px-2">
                <div>The count of Monte Cristo</div>
                <div>ID: 43756</div>
              </div>
            </div>
          </td>
          <td>Mark</td>
          <td>Otto</td>
          <td>$3.50</td>
          <td>Otto</td>
          <td> <span  style={{
                      
                      paddingRight: "8px",
                      paddingLeft: "8px",
                      paddingTop : '3px',
                      paddingBottom : '3px',
                      borderRadius: "5px",
                       color : '#7060FF',
                       background : '#262B31',
                    }}>Delivery</span></td>
        </tr>
        <tr>
        <td>
            <div className="contents d-flex ">
              <div className="icons ">
                <StoreVisitors  style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      
                      }}/>
              </div>
              <div className="iconscontent px-2">
                <div>The count of Monte Cristo</div>
                <div>ID: 43756</div>
              </div>
            </div>
          </td>
          <td>Mark</td>
          <td>Otto</td>
          <td>$3.50</td>
          <td>Otto</td>
          <td> <span  style={{
                      
                      paddingRight: "8px",
                      paddingLeft: "8px",
                      paddingTop : '3px',
                      paddingBottom : '3px',
                      borderRadius: "5px",
                       color : '#1ECE4F',
                       background : '#262B31',
                    }}>Delivery</span></td>
        </tr>
        <tr>
        <td>
            <div className="contents d-flex ">
              <div className="icons ">
                <StoreVisitors  style={{
                        fontSize: "30px",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        marginRight: "10px",
                        borderRadius: "5px",
                      
                      }}/>
              </div>
              <div className="iconscontent px-2">
                <div>The count of Monte Cristo</div>
                <div>ID: 43756</div>
              </div>
            </div>
          </td>
          <td>Mark</td>
          <td>Otto</td>
          <td>$3.50</td>
          <td>Otto</td>
          <td> <span  style={{
                      
                      paddingRight: "8px",
                      paddingLeft: "8px",
                      paddingTop : '3px',
                      paddingBottom : '3px',
                      borderRadius: "5px",
                       color : '#7060FF',
                       background : '#262B31',
                    }}>Delivery</span></td>
        </tr>
      </tbody>
    </Table>
    </div>
  );
}

export default Tables;
